
export const ActiveUserStatusData=[
    {
        Link:'Messages',
        user:'245'
    },
    {
        Link:'Connections',
        user:'455'
    },
]
export const DashboardStatusData = [
    {
        title: 'New Users',
        value: '8,925',
        iconClass: 'fa fa-smile-o fa-lg',
     
        iconBgClass: 'bg-warning'
    },
    {
        title: 'Total Users',
        value: 'user count - 100',
        iconClass: 'fa fa-user fa-lg',
 
        iconBgClass: 'bg-success'
    },
    {
        title: 'Active Users',
        value: 'Active user count - 61',
        iconClass: 'fa fa-user fa-lg',

        iconBgClass: 'bg-danger'
    },
    {
        title: 'Active Astrologers',
        value: ' Astrologers count - 55',
        iconClass: 'fa fa-user fa-lg',
        
        iconBgClass: 'bg-warning'
    },
    {
        title: 'Ongoing Consultation',
        value: '856',
        iconClass: 'fa fa-comments fa-lg',

        iconBgClass: 'bg-success'
    },
  
]

export const TodayData = [
    {
        title: 'Customers',
        value: '14,208',
        iconClass: 'icofont-student-alt fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Order',
        value: '2314',
        iconClass: 'icofont-shopping-cart fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Sale',
        value: '$1770',
        iconClass: 'icofont-sale-discount fs-3 color-santa-fe',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Item Sale',
        value: '185',
        iconClass: 'icofont-calculator-alt-2 fs-3 color-danger',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Sale',
        value: '$35000',
        iconClass: 'icofont-calculator-alt-1 fs-3 color-lightblue',
        cardBg: 'bg-light'
    },
    {
        title: 'Visitors',
        value: '11452',
        iconClass: 'icofont-users-social fs-3 color-light-success',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Products',
        value: '184511',
        iconClass: 'icofont-bag fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Top Selling Item',
        value: '122',
        iconClass: 'icofont-star fs-3 color-lightyellow',
        cardBg: 'bg-light'
    },
    {
        title: 'Dealership',
        value: '32',
        iconClass: 'icofont-handshake-deal fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    }
]

export const WeekData = [
    {
        title: 'Customers',
        value: '54,208',
        iconClass: 'icofont-student-alt fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Order',
        value: '12314',
        iconClass: 'icofont-shopping-cart fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Sale',
        value: '$11770',
        iconClass: 'icofont-sale-discount fs-3 color-santa-fe',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Item Sale',
        value: '1185',
        iconClass: 'icofont-calculator-alt-2 fs-3 color-danger',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Sale',
        value: '$135000',
        iconClass: 'icofont-calculator-alt-1 fs-3 color-lightblue',
        cardBg: 'bg-light'
    },
    {
        title: 'Visitors',
        value: '111452',
        iconClass: 'icofont-users-social fs-3 color-light-success',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Products',
        value: '194511',
        iconClass: 'icofont-bag fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Top Selling Item',
        value: '1122',
        iconClass: 'icofont-star fs-3 color-lightyellow',
        cardBg: 'bg-light'
    },
    {
        title: 'Dealership',
        value: '132',
        iconClass: 'icofont-handshake-deal fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    }
]

export const MonthData = [
    {
        title: 'Customers',
        value: '74,208',
        iconClass: 'icofont-student-alt fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Order',
        value: '22314',
        iconClass: 'icofont-shopping-cart fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Sale',
        value: '$21770',
        iconClass: 'icofont-sale-discount fs-3 color-santa-fe',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Item Sale',
        value: '2185',
        iconClass: 'icofont-calculator-alt-2 fs-3 color-danger',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Sale',
        value: '$235000',
        iconClass: 'icofont-calculator-alt-1 fs-3 color-lightblue',
        cardBg: 'bg-light'
    },
    {
        title: 'Visitors',
        value: '211452',
        iconClass: 'icofont-users-social fs-3 color-light-success',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Products',
        value: '284511',
        iconClass: 'icofont-bag fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Top Selling Item',
        value: '222',
        iconClass: 'icofont-star fs-3 color-lightyellow',
        cardBg: 'bg-light'
    },
    {
        title: 'Dealership',
        value: '232',
        iconClass: 'icofont-handshake-deal fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    }
]

export const YearData = [
    {
        title: 'Customers',
        value: '104,208',
        iconClass: 'icofont-student-alt fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Order',
        value: '252314',
        iconClass: 'icofont-shopping-cart fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Sale',
        value: '$852770',
        iconClass: 'icofont-sale-discount fs-3 color-santa-fe',
        cardBg: 'bg-light'
    },
    {
        title: 'Avg Item Sale',
        value: '75885',
        iconClass: 'icofont-calculator-alt-2 fs-3 color-danger',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Sale',
        value: '$350000',
        iconClass: 'icofont-calculator-alt-1 fs-3 color-lightblue',
        cardBg: 'bg-light'
    },
    {
        title: 'Visitors',
        value: '114521452',
        iconClass: 'icofont-users-social fs-3 color-light-success',
        cardBg: 'bg-light'
    },
    {
        title: 'Total Products',
        value: '884511',
        iconClass: 'icofont-bag fs-3 color-light-orange',
        cardBg: 'bg-light'
    },
    {
        title: 'Top Selling Item',
        value: '7522',
        iconClass: 'icofont-star fs-3 color-lightyellow',
        cardBg: 'bg-light'
    },
    {
        title: 'Dealership',
        value: '1832',
        iconClass: 'icofont-handshake-deal fs-3 color-lavender-purple',
        cardBg: 'bg-light'
    }
]
